export const Warning = () => (
  <svg className='w-3 h-3 flex-shrink-0' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='6' cy='6' r='6' fill='#E76841' />
    <text x='6' y='9' textAnchor='middle' fill='white' fontSize='8' fontWeight='bold'>!</text>
  </svg>
);
